/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsSlidingText = {
    init: function ($section) {
        let marqueeSlider = document.querySelector("[data-sliding-text]");
        if (!marqueeSlider) return;

        let mainTicker = new Flickity(marqueeSlider, {
        accessibility: true,
        resize: true,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        percentPosition: true,
        setGallerySize: true,
        groupCells: false
        }); 

        let speed = window.innerWidth <= 798 ? 1 : 1.2;
        let direction = -1; // scroll left
        mainTicker.x = 0;

        let requestId;

        function play() {
        mainTicker.x += direction * speed;
        mainTicker.settle(mainTicker.x);

        let sliderWidth = mainTicker.slideableWidth;
        let currentPos = Math.abs(mainTicker.x);

        // When reached the end, reset to start (simulate infinite scroll)
        if (currentPos >= sliderWidth) {
            mainTicker.x = 0;
            mainTicker.settle(mainTicker.x);
        }

        requestId = requestAnimationFrame(play);
        }

        function pause() {
        if (requestId) {
            cancelAnimationFrame(requestId);
            requestId = undefined;
        }
        }

        marqueeSlider.addEventListener("mouseenter", pause);
        marqueeSlider.addEventListener("mouseleave", play);

        play();

    },
    unload: function ($section) {}
  }

  /******/
})()
  ;